const autoNgTemplateLoaderTemplate1 = require('./devices-panel.html');

angular.module('shbdeployer.docker').component('devicesPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    devices: '<',
  },
});
